<template>
  <div>
    <v-row class="myContainer">
      <v-col
        v-for="list in profileLists"
        :key="list.title"
        cols="12"
        style="padding: 0"
      >
        <v-hover v-slot="{ hover }">
          <v-img
            :src="list.src"
            :lazy-src="list.src"
            aspect-ratio="1"
            class="grey lighten-2 profileImage"
          >
            <v-expand-transition>
              <div
                v-if="hover"
                class="
                  transition-slow-in-fast-out
                  darken-2
                  black
                  v-card--reveal
                  white--text
                "
              >
                <h1>{{ list.title }}</h1>
                <p
                  v-for="(text, index) in list.texts"
                  :key="index"
                  class="profileText"
                >
                  {{ text }}
                </p>
                <div v-if="list.html">
                  <div
                    v-for="html in list.html"
                    :key="html.index"
                    v-html="html"
                  ></div>
                </div>
              </div>
            </v-expand-transition>
            <div v-if="profileLists.length != list.id">
              <scroll-arrow></scroll-arrow>
            </div>
          </v-img>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import scrollArrow from "../components/layouts/ScrollArrow.vue";
// import myHobbySoccer from "../views/MyHobby_Soccer.vue";
// import fadeIn from "../components/Fade-In.vue";

export default {
  components: {
    scrollArrow,
    // myHobbySoccer,
    // fadeIn,
  },

  data() {
    return {
      profileLists: [
        {
          id: 1,
          title: "About Me",
          texts: [
            "1996年生まれ",
            "プログラミングを独学で勉強中",
            "性格タイプはISTP",
          ],
          src: require("../assets/profile/avicii_touchme.jpeg"),
        },
        {
          id: 2,
          title: "Soccer",
          texts: [
            "サッカーが好きです",
            "プレミアとラ・リーガを観ます",
            "好きなチームはレアル・マドリード",
            "好きな選手はC•ロナウドと久保建英",
          ],
          src: require("../assets/profile/soccer.webp"),
        },
        {
          id: 3,
          title: "Music",
          texts: ["綺麗なEDMが好きです", "これを聴けばEDMの印象が変わる↓"],
          src: require("../assets/profile/closer.webp"),
          html: [
            '<iframe width="300" height="150" src="https://www.youtube-nocookie.com/embed/PT2_F-1esPk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
            '<iframe width="300" height="150" src="https://www.youtube-nocookie.com/embed/60Ir12IvvLA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
          ],
        },
        {
          id: 4,
          title: "Fushion",
          texts: [""],
          src: require("../assets/profile/stein_19aw.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
h1 {
  text-align: left;
  font-size: 3em;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.7;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 1.5em;
}

.myContainer {
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  -ms-overflow-style: none; /* IE, Edge 対応 */
  scrollbar-width: none; /* Firefox 対応（スクロールバー削除） */
  height: 92.5vh;
  width: 100%;
  margin: 0;
}

.myContainer::-webkit-scrollbar {
  display: none; /* スクロールバーが2つ出てしまうので、片方削除 */
}

.profileImage {
  max-height: 93vh;
  padding: 0;
  height: 93vh;
  width: 100%;
  scroll-snap-align: start;
  filter: grayscale(100%);
}

.profileText {
  margin: 20px;
}
</style>